import { Field, FieldProps } from "formik";
import * as React from "react";

interface IProps {
  classes: { btn: string };
  setFieldValue: (name: string, value: File) => void;
}

export const FileInput = ({ classes, setFieldValue }: IProps) => {
  return (
    <Field name="file">
      {({ field: { name } }: FieldProps) => {
        return (
          <input
            accept=".csv"
            name={name}
            type="file"
            className={classes.btn}
            onChange={(event: any) => {
              setFieldValue("file", (event.target.files as FileList)[0]);
            }}
          />
        );
      }}
    </Field>
  );
};
